module.exports = __webpack_public_path__ + "img/heart-full.645b720b.svg";